<script>
  import { PKClient } from "../services/PKClient.js";
  import { GQLNow } from "gql-now";

  import {
    App,
    f7,
    Page,
    CardFooter,
    CardContent,
    CardHeader,
    PageContent,
    Card,
    Navbar,
    NavLeft,
    NavTitle,
    NavTitleLarge,
    NavRight,
    Link,
    Toolbar,
    Block,
    BlockTitle,
    List,
    ListItem,
    ListInput,
    Row,
    Col,
    Button,
    LoginScreenTitle,
    ListButton,
    BlockFooter,
  } from "framework7-svelte";

  import { ORG_ID, MEMBER_SERVICES_URL } from "../js/auth";

  export let f7route;
  export let f7router;

  let mobile = "";
  let session;

  async function signIn() {
    try {
      let sessionData = await get_admin_session_otp();
      if (sessionData && sessionData.get_admin_session_otp && sessionData.get_admin_session_otp.status === true) {
        localStorage.setItem("session-key", sessionData.get_admin_session_otp.session_id);
        f7router.navigate(`/admin-login-otp/?mobile=${mobile}`);
      } else {
        f7.dialog.alert("Invalid credentials");
      }
    } catch (err) {
      console.log(err);
      let errMsg = "Invalid credentials";
      if (err && err.data && err.data.errors && err.data.errors.length > 0) {
        errMsg = err.data.errors[0].message || "Invalid credentials";
      } else if (err && err.message) {
        errMsg = err.message;
      }
      f7.dialog.alert(errMsg);
    }
  }

  const get_admin_session_otp = async () => {
    let cleanMobile = mobile ? mobile.toString().trim() : "";
    if (cleanMobile && cleanMobile.length === 10) {
      let obj = new GQLNow(MEMBER_SERVICES_URL, {
        "x-trdr-org": ORG_ID,
      });
      try {
        f7.preloader.show();
        let response = await obj.mutation(
          "get_admin_session_otp",
          { mobile: cleanMobile },
          "status session_id"
        );
        session = response.data;
        f7.preloader.hide();
        return session;
      } catch (err) {
        f7.preloader.hide();
        throw err;
      }
    } else {
      f7.dialog.alert("Please enter a valid 10-digit mobile number");
    }
  };
</script>

<Page name="merchant-login" noToolbar noNavbar noSwipeback loginScreen>
  <LoginScreenTitle>Admin Login</LoginScreenTitle>
  <List form>
    <ListInput
      label="Mobile"
      type="text"
      placeholder=""
      value={mobile}
      onInput={(e) => (mobile = e.target.value)}
    />
    <!-- <ListInput
      label="OTP"
      type="tel"
      placeholder="Your password"
      value={otp}
      onInput={(e) => (otp = e.target.value)}
    /> -->
  </List>
  <List>
    <Button fill onClick={signIn}>Proceed</Button>
    <!-- <ListButton>Forgot Password</ListButton> -->
  </List>
  <BlockFooter class="margin-top-half">
    <br />
   
  </BlockFooter>
</Page>

<style>
  #partitioned {
  padding-left: 15px;
  letter-spacing: 42px;
  border: 0;
  background-image: linear-gradient(to left, black 70%, rgba(255, 255, 255, 0) 0%);
  background-position: bottom;
  background-size: 50px 1px;
  background-repeat: repeat-x;
  background-position-x: 35px;
  width: 220px;
  min-width: 220px;
}

#divInner{
  left: 0;
  position: sticky;
}

#divOuter{
  width: 190px; 
  overflow: hidden;
}
</style>
